export const logger = {
  debug: (...args: any[]) => {
    if (import.meta.env.DEV) {
      console.log('[DEBUG]', ...args);
    }
  },
  info: (message: string) => {
    console.log('[INFO]', message);
  },
  error: (message: string, error?: any) => {
    // Sanitize error objects (remove PII)
    const sanitized = error ? { 
      message: error.message,
      code: error.code,
      status: error.status
    } : null;
    console.error('[ERROR]', message, sanitized);
  }
};
